const CSS_ACTIVE = 'is-active';

const MastheadElement = document.getElementById("explore");
const ParallaxRoot = document.querySelector('.MastheadBackground');
if (ParallaxRoot) {
    const ParallaxBackground = ParallaxRoot.querySelector('.MastheadBackground-background');
    const BackgroundGrid = ParallaxRoot.querySelector('.MastheadBackground-grid');
    const BackgroundImage = ParallaxRoot.querySelector('.MastheadBackground-backgroundImage');
    const BackgroundGridImage = ParallaxRoot.querySelector('.MastheadBackground-gridImage');
    const BackgroundContainer = ParallaxRoot.querySelector('.MastheadBackground-container');
    const BackgroundKey = ParallaxRoot.querySelector('.MastheadBackground-key');
    const BackgroundOrb = ParallaxRoot.querySelector('.MastheadBackground-orb');
    const BackgroundAura = ParallaxRoot.querySelector('.MastheadBackground-aura');
    const BackgroundCanvas = ParallaxRoot.querySelector('.MastheadBackground-canvas');
    const BackgroundDark = ParallaxRoot.querySelector('.MastheadBackground-dark');
    const BackgroundOverlay = document.querySelector('.MastheadWrapper-overlay');
    const BackgroundLeft = document.querySelector('.MastheadWrapper-left');
    const BackgroundRight = document.querySelector('.MastheadWrapper-right');
    const BackgroundDeltaFactor = -0.1;
    const DriftIngressTime = 1000;
    const DriftPauseTime = 2500;
    const DriftDecayTime = 5000;
    const DriftResumeTime = DriftPauseTime + DriftDecayTime;
    const MotionScaleFactor = 5.0;
    const StageOneDuration = 1200;
    const StageTwoDuration = 600;
    const StageThreeDuration = 600;
    const StageTwoCutoff = StageOneDuration + StageTwoDuration;
    const StageThreeCutoff = StageTwoCutoff + StageThreeDuration;
    let syncFactor = 0;
    let mouseX, mouseY;
    let loadComplete = 0;
    let lastMouseEvent = 0;
    let previousFrame = 0;
    let loadAnimating = true;

    const CanvasContext = BackgroundCanvas.getContext("2d");
    const BufferCanvas = document.createElement("canvas");
    BufferCanvas.width = BackgroundCanvas.width;
    BufferCanvas.height = BackgroundCanvas.height;
    const BufferContext = BufferCanvas.getContext("2d");

    function lerp(start, end, progress) {
        return start + (end - start) * progress;
    }
    function easeOutQuad(x) {
        return 1 - (1 - x) * (1 - x);
    }
    function easeInOutSine(x) {
        return -(Math.cos(Math.PI * x) - 1) / 2;
    }
    function calcDriftFactor() {
        const ms = Date.now() % 30000;
        const progress = ms / 30000.0;
        const rad = progress * 2 * Math.PI;
        const driftX = Math.cos(rad);
        const driftY = Math.sin(rad) * 0.5625;

        return {driftX, driftY}
    }

    function initMask() {
        CanvasContext.clearRect(0, 0, BackgroundCanvas.width, BackgroundCanvas.height);
        requestAnimationFrame(sync);
    }
    const OrbAnchorPoint = {
        x: BufferCanvas.width * 0.7325,
        y: BufferCanvas.height * 0.14
    }
    function switchCanvasses() {
        CanvasContext.clearRect(0, 0, BackgroundCanvas.width, BackgroundCanvas.height);
        CanvasContext.drawImage(BufferCanvas, 0, 0);
        BufferContext.clearRect(0, 0, BackgroundCanvas.width, BackgroundCanvas.height);
    }
    function drawStageOneAnimation(loadElapsed) {
        const progress = loadElapsed / StageOneDuration;
        const left = lerp(-500, 0, easeOutQuad(progress));
        const top = 200.0 - (200.0 * progress) - (250.0 * Math.sin(Math.PI * progress));
        const rotate = lerp(-360, 0, progress);
        const scale = 1 + (1 - progress);
        const transform = `translate(${left}%, ${top}%) rotate(${rotate}deg) scale(${scale})`;
        const brightness = lerp(0.25, 1.5, easeOutQuad(progress));
        const blur = lerp(10, 0, progress);
        const filter = `opacity(${easeOutQuad(progress)}) brightness(${brightness}) blur(${blur}px)`;

        BackgroundOrb.style.setProperty(
            '--masthead-orb-transform',
            transform
        );
        BackgroundOrb.style.setProperty(
            '--masthead-orb-filter',
            filter
        );
    }
    function drawStageTwoAnimation(loadElapsed) {
        switchCanvasses();

        BackgroundDark.classList.remove(CSS_ACTIVE);

        const progress = loadElapsed / StageTwoDuration;
        const gridRadius = BufferCanvas.width * progress;
        const radius = gridRadius - 200 - (100 * progress);

        BufferContext.save();

        BufferContext.fillStyle = 'white';
        BufferContext.beginPath();
        BufferContext.arc(OrbAnchorPoint.x, OrbAnchorPoint.y, gridRadius, 0, Math.PI * 2);
        BufferContext.clip();
        BufferContext.drawImage(BackgroundGridImage, 0, 0, BackgroundCanvas.width, BackgroundCanvas.height);
        BufferContext.globalCompositeOperation = "source-in";
        BufferContext.drawImage(BackgroundImage, 0, 0, BackgroundCanvas.width, BackgroundCanvas.height);
        BufferContext.globalCompositeOperation = "source-over";


        if (radius > 0) {
            BufferContext.filter = `blur(${20*(1-progress)}px)`;
            BufferContext.beginPath();
            BufferContext.arc(OrbAnchorPoint.x, OrbAnchorPoint.y, radius, 0, Math.PI * 2);
            BufferContext.clip();
            BufferContext.filter = null;
            BufferContext.drawImage(BackgroundImage, 0, 0, BufferCanvas.width, BufferCanvas.height);
        }

        BufferContext.restore();

        const brightness = lerp(1.5, 1, easeOutQuad(progress));
        const filter = `brightness(${2 - progress})`;
        BackgroundCanvas.style.setProperty('--masthead-canvas-filter', filter);
        BackgroundOrb.style.setProperty('--masthead-orb-transform', null);
        BackgroundOrb.style.setProperty('--masthead-orb-filter', `brightness(${brightness})`);
    }
    function drawStageThreeAnimation(loadElapsed) {
        switchCanvasses();

        ParallaxRoot.classList.add(CSS_ACTIVE);
        BackgroundKey.classList.add(CSS_ACTIVE);
        ParallaxBackground.classList.add(CSS_ACTIVE);
        BackgroundOverlay.classList.add(CSS_ACTIVE);
        BackgroundDark.classList.remove(CSS_ACTIVE);
        BackgroundCanvas.style.setProperty('--masthead-canvas-filter', null);

        const progress = loadElapsed / StageThreeDuration;
        const filter = `opacity(${1-progress})`;
        BackgroundOrb.style.setProperty(
            '--masthead-orb-filter',
            filter
        );
        BackgroundOrb.style.setProperty('--masthead-orb-transform', null);
    }

    function disableCanvas() {
        CanvasContext.clearRect(0, 0, BackgroundCanvas.width, BackgroundCanvas.height);
        BackgroundContainer.style.filter = null;
        BufferContext.clearRect(0, 0, BackgroundCanvas.width, BackgroundCanvas.height);
        BackgroundGrid.classList.add(CSS_ACTIVE);
        BackgroundOrb.style.setProperty('--masthead-orb-transform', null);
        BackgroundOrb.style.setProperty('--masthead-orb-filter', null);
        BackgroundAura.classList.add(CSS_ACTIVE);
        loadAnimating = false;
    }

    function doLoadAnimation(loadElapsed) {
        if (loadElapsed < StageOneDuration) {
            drawStageOneAnimation(loadElapsed)
        } else if (loadElapsed < StageTwoCutoff) {
            drawStageTwoAnimation(loadElapsed - StageOneDuration)
        } else if (loadElapsed < StageThreeCutoff) {
            drawStageThreeAnimation(loadElapsed - StageTwoCutoff)
        } else {
            disableCanvas();
        }
    }

    function doStaticAnimation(elapsed) {
        const jitter1 = 0.25 * Math.sin(Math.PI * (elapsed % 300) / 300);
        const jitter2 = 0.25 * Math.sin(Math.PI * (elapsed % 550) / 550);
        const opacity = Math.min(1, elapsed / 2000) * (0.5 + jitter1 + jitter2);
        BackgroundAura.style.filter = `opacity(${opacity})`;
    }

    function sync(currentFrame) {
        if (previousFrame < currentFrame) {
            const elapsed = currentFrame - previousFrame;
            previousFrame = currentFrame;

            const now = Date.now();
            const loadElapsed = now - loadComplete;
            if (loadAnimating) {
                doLoadAnimation(loadElapsed);
            }
            if (loadElapsed >= StageOneDuration) {
                doStaticAnimation(loadElapsed - StageThreeCutoff);
            }

            // Only do background shift at tablet+
            if (PageComponents.isTabletUp()) {
                const timeSinceLastMouseEvent = now - lastMouseEvent;

                let deltaX;
                let deltaY;
                const {driftX, driftY} = calcDriftFactor();
                if (timeSinceLastMouseEvent < DriftResumeTime) {
                    const mouseMax = MastheadElement.getBoundingClientRect().width / 2;
                    if (timeSinceLastMouseEvent > DriftPauseTime) {
                        syncFactor = 1.0 - (timeSinceLastMouseEvent - DriftPauseTime) / DriftDecayTime;
                    } else {
                        if (syncFactor < 1.0) {
                            syncFactor += (elapsed / DriftIngressTime);
                            if (syncFactor > 1.0) syncFactor = 1.0;
                        }
                    }
                    deltaX = lerp(driftX, (mouseX / mouseMax), easeInOutSine(syncFactor));
                    deltaY = lerp(driftY, (mouseY / mouseMax), easeInOutSine(syncFactor));
                } else {
                    deltaX = driftX;
                    deltaY = driftY;
                }

                deltaX *= MotionScaleFactor;
                deltaY *= MotionScaleFactor;

                ParallaxBackground.style.transform = `translate(${-50 + BackgroundDeltaFactor * deltaX}%, ${-50 + BackgroundDeltaFactor * deltaY}%)`;
                if (!loadAnimating) {
                    BackgroundCanvas.style.transform = `translate(${-50 - BackgroundDeltaFactor * deltaX}%, ${-50 - BackgroundDeltaFactor * deltaY}%)`;
                    BackgroundLeft.style.transform = `translate(${-50 + -5 * BackgroundDeltaFactor * deltaX}%, ${-50 + -5 * BackgroundDeltaFactor * deltaY}%)`;
                    BackgroundRight.style.transform = `translate(${-50 + -4 * BackgroundDeltaFactor * deltaX}%, ${-50 + -4 * BackgroundDeltaFactor * deltaY}%)`;
                }
            } else {
                ParallaxBackground.style.transform = null;
                if (!loadAnimating) BackgroundCanvas.style.transform = null;
            }

        }
        requestAnimationFrame(sync);
    }

    let lastX = -1;
    let lastY = -1;
    function syncMouse(e) {
        const rect = MastheadElement.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.width * .28125;
        mouseX = e.clientX - centerX;
        mouseY = e.clientY - centerY;
        lastMouseEvent = Date.now();
        if (!loadAnimating) {
            const canvasRect = BackgroundCanvas.getBoundingClientRect();
            const canvasX = e.clientX - canvasRect.left;
            const canvasY = e.clientY - canvasRect.top;
            lastX = canvasX;
            lastY = canvasY;
        }
    }

    const LoadDelay = 1000;
    const loadStart = Date.now();
    window.addEventListener('load', () => {
        loadComplete = Date.now();
        const elapsed = loadComplete - loadStart;
        // Delay to pad out 2s delay
        if (elapsed < LoadDelay) {
            setTimeout(() => {
                loadComplete = Date.now();
                requestAnimationFrame(initMask);
            }, LoadDelay - elapsed);
        }
        // Immediate start
        else {
            requestAnimationFrame(initMask);
        }

        MastheadElement.addEventListener("mousemove", syncMouse);

    });
}
